import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { TAGS } from '../constants'

const updateTagShow = async (id: number) => {
  await fetchAPI({
    method: 'put',
    path: `/tags/${id}/show_on_search`,
  })
}

export const useUpdateTagShow = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(updateTagShow, {
    onSuccess: async () => {
      await queryClient.refetchQueries([TAGS])

      toast({
        description: t('views.admin.tags.index.update_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
